import { JwtContext } from 'contexts/JwtContext';
import { useContext } from 'react';

export const useJwt = () => {
	const context = useContext(JwtContext);
	if (!context) {
		throw new Error('useJwt must be used within a JwtProvider');
	}
	return {
		setTokens: context.setTokens, // only for OIDC login
		accessJwt: context.accessJwt,
		login: context.login,
		logout: context.logout,
		arePermissionsInToken: context.arePermissionsInToken,
	};
};
